import { tv, type VariantProps } from "tailwind-variants";

import { Span } from "./Span";

export const badgeVariants = tv({
	base: "flex w-fit shrink-0 items-center justify-center rounded-full border px-0.5 font-medium",
	variants: {
		size: {
			xs: "h-3.5 min-w-3.5 text-[9px]",
			sm: "h-4 min-w-4 text-[10px]",
			md: "h-5 min-w-5 text-xs",
			lg: "h-6 min-w-6 text-sm",
			xl: "text-md h-7 min-w-7",
		},
		color: {
			primary: "border-primary-border bg-primary text-on-primary",
			secondary: "border-secondary-border bg-secondary text-on-secondary",
			danger: "border-danger-border bg-danger text-on-danger",
			warning: "border-warning-border bg-warning text-on-warning",
			success: "border-success-border bg-success text-on-success",
			info: "border-info-border bg-info text-on-info",
			onGlobalBackground: "text-on-primary",
			cta: "border-cta-border bg-cta text-on-cta",
		},
	},
});

export type BadgeVariant = VariantProps<typeof badgeVariants>;

export type BadgeProps = BadgeVariant & {
	readonly count: number;
	readonly className?: string;
};

export function Badge({ color = "primary", size = "md", count, className }: BadgeProps) {
	const base = badgeVariants({ color, size, className });

	return <Span className={base}>{count}</Span>;
}
